// Components
import Container from '@/components/global-components/Container';
import ReadMoreCard from './sub-components/ReadMoreCard';
import Keys from './sub-components/Keys';
import StoryOfCPI from './sub-components/StoryOfCPI';
import Reasons from './sub-components/Reasons';

// Themes
import theme from '@/themes/index';

const AboutCPIBody = ({
  content: {
    aboutCpi,
    keys,
    storyOfCpi,
    reasons,
    ourStory,
  },
}) => {
  return (
    <>
      <section className='main'>
        <Container>
          <ReadMoreCard content={aboutCpi} />
        </Container>
      </section>
      <section className='keys'>
        <div className='figure right-figure'>
          <img src={'/assets/images/Icon_social_1.png'}/>
        </div>
        <Container>
          <Keys content={keys} />
        </Container>
        <div className='figure left-figure'>
          <img src={'/assets/images/Icon_social_2.png'}/>
        </div>
      </section>
      <section  className='reasons'>
        <Container>
          <Reasons content={reasons} />
        </Container>
      </section>
      <section  className='story'>
        <Container>
          <StoryOfCPI content={storyOfCpi} />
        </Container>
      </section>
      <section className='our-story'>
        <Container>
          <ReadMoreCard content={ourStory} />
        </Container>
      </section>
      <style jsx>{`
        section:not(.story) {
          padding: 3rem 2rem;
        }

        section.keys {
          position: relative;
        }

        div.figure {
          position: absolute;
          display: flex;
          width: 100%;
          margin: 0 auto;
          z-index: -1;
        }

        div.right-figure {
          top: 0;
          flex-flow: row-reverse;
          padding-right: 3%;
        }

        div.left-figure {
          bottom: 0;
          flex-flow: row;
          padding-left: 3%;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          section:not(.story) {
            padding: 3rem 4.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default AboutCPIBody;
